/**
 * HHT2 TimeLine Contents 정보
 * @type {string[]}
 */

export const HHT2_EP3_ANSWERS = [
    'Matt’s game console is broken! Matt asks Harry, "Can you fix it?"',
    'Harry fixes Matt’s game console, and Holly helps.',
    'Stephanie comes into the living room. She asks, "Who wants ice cream?"',
    'Harry and Holly grab the ice cream and eat it. But Matt is busy playing games..',
    'Stephanie thinks about Tony. She asks Harry, "Will you go give him some ice cream?"',
    'When Harry goes upstairs, Harry screams, "No way! My books!"',
    'Tony has made New York City out of books!',
    'But Harry isn’t happy. So, he says, "We’ll just put my books back in order!"',
    'But Holly says, "My ice cream is melting," and she runs away.',
    'Then Tony says, "Ice cream? Where?" and runs away, too. Poor Harry!',
];

// export const HHT2_EP3_ANSWER_SOUNDS = [
//     '/HHT2_AB EP03_dyr01.mp3',
//     '/HHT2_AB EP03_dyr02.mp3',
//     '/HHT2_AB EP03_dyr03.mp3',
//     '/HHT2_AB EP03_dyr04.mp3',
//     '/HHT2_AB EP03_dyr05.mp3',
//     '/HHT2_AB EP03_dyr06.mp3',
//     '/HHT2_AB EP03_dyr07.mp3',
//     '/HHT2_AB EP03_dyr08.mp3',
//     '/HHT2_AB EP03_dyr09.mp3',
//     '/HHT2_AB EP03_dyr10.mp3',
// ];

export const HHT2_EP3_ANSWER_SOUNDS = [
    '/94a4537dec3ee34cb260da5ab27f0828.mp3',
    '/9d281f07a91e97ff851e18e0e3e52b6b.mp3',
    '/97db131fcdaaa0ed4ca5f9dacee95fb2.mp3',
    '/f68fc2409f65610ec397293152bb0ba3.mp3',
    '/ee7d482c849a6d96a99a580070fcb81a.mp3',
    '/1a9d9e5198c476bf23edf0d579f69672.mp3',
    '/d5504c15f0f20a797e2992b4bba9293c.mp3',
    '/1c3140992f0c1adde2f42c095e438734.mp3',
    '/f9172fea191be6f1f50dbf536aa3d007.mp3',
    '/678e0fc2c7979b95d4b4f4a819a96a0b.mp3',
];


export const HHT2_EP3_QUIZ_ITEMS = [{
    'A': HHT2_EP3_ANSWERS[1],
    'B': HHT2_EP3_ANSWERS[8],
    'SoundIndexA': 1,
    'SoundIndexB': 8,
    'answer': HHT2_EP3_ANSWERS[1],
    'sound': [2, 3],
    'exception': false,
},
    {
        'A': HHT2_EP3_ANSWERS[4],
        'B': HHT2_EP3_ANSWERS[6],
        'SoundIndexA': 4,
        'SoundIndexB': 6,
        'answer': HHT2_EP3_ANSWERS[4],
        'sound': [5, 6],
        'exception': false,
    },
    {
        'A': HHT2_EP3_ANSWERS[0],
        'B': HHT2_EP3_ANSWERS[7],
        'SoundIndexA': 0,
        'SoundIndexB': 7,
        'answer': HHT2_EP3_ANSWERS[7],
        'sound': [8],
        'exception': false,
    },
    {
        'A': HHT2_EP3_ANSWERS[2],
        'B': HHT2_EP3_ANSWERS[9],
        'SoundIndexA': 2,
        'SoundIndexB': 9,
        'answer': HHT2_EP3_ANSWERS[9],
        'sound': [9],
        'exception': false,
    },
]
